import { render, staticRenderFns } from "./CourseDetailsDialog.vue?vue&type=template&id=a2dc8c9e&scoped=true&"
import script from "./CourseDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc8c9e",
  null
  
)

export default component.exports